import type { Cell, Difficulty, GameConfig } from "./types.js";

export const PRESET_CONFIGS: Record<Exclude<Difficulty, "custom">, GameConfig> = {
  easy: { rows: 6, cols: 10, connect: 4, difficulty: "easy" },
  medium: { rows: 7, cols: 12, connect: 5, difficulty: "medium" },
  hard: { rows: 8, cols: 14, connect: 5, difficulty: "hard" },
  advanced: { rows: 10, cols: 15, connect: 6, difficulty: "advanced" }
};

export function createEmptyBoard(rows: number, cols: number): Cell[][] {
  return Array.from({ length: rows }, () => Array.from({ length: cols }, () => 0 as Cell));
}

export function dropPiece(board: Cell[][], col: number, piece: 1 | 2): { ok: true; row: number; board: Cell[][] } | { ok: false; reason: string } {
  if (col < 0 || col >= board[0].length) return { ok: false, reason: "Invalid column." };
  const copy = board.map((r) => [...r]);
  for (let r = copy.length - 1; r >= 0; r -= 1) {
    if (copy[r][col] === 0) {
      copy[r][col] = piece;
      return { ok: true, row: r, board: copy };
    }
  }
  return { ok: false, reason: "Column is full." };
}

export function computeWinner(board: Cell[][], connect: number): { winner: 0 | 1 | 2; cells: Array<{ r: number; c: number }> } {
  const rows = board.length;
  const cols = board[0].length;
  const dirs: Array<[number, number]> = [[1, 0], [0, 1], [1, 1], [1, -1]];

  for (let r = 0; r < rows; r += 1) {
    for (let c = 0; c < cols; c += 1) {
      const piece = board[r][c];
      if (piece === 0) continue;
      for (const [dr, dc] of dirs) {
        const cells: Array<{ r: number; c: number }> = [{ r, c }];
        let rr = r;
        let cc = c;
        for (let i = 1; i < connect; i += 1) {
          rr += dr;
          cc += dc;
          if (rr < 0 || rr >= rows || cc < 0 || cc >= cols) break;
          if (board[rr][cc] !== piece) break;
          cells.push({ r: rr, c: cc });
        }
        if (cells.length === connect) return { winner: piece, cells };
      }
    }
  }

  return { winner: 0, cells: [] };
}

export function isBoardFull(board: Cell[][]): boolean {
  return board.every((row) => row.every((cell) => cell !== 0));
}
